'use strict';

var debug;
if (process.env.NODE_ENV !== 'production') {
    debug = require('debug')('hbnb:module:webview:setTitle');
}

var _invoke = require('../invoke');

/**
 * 修改标题
 *
 * 支持版本
 * + iHotel/5.8+
 *
 * @memberof webview
 * @static
 * @name setTitle
 * @param {String} title 标题
 * @return {Undefined}
 * @example
 *  hbnb.webview.setTitle('new title');
 */
module.exports = function(title) {
    if (process.env.NODE_ENV !== 'production') {
        debug('title is %s', title);
    }

    _invoke('webview', 'set_title', {
        title: title
    });
};



//////////////////
// WEBPACK FOOTER
// ./~/@dp/knb/~/@hfe/hbnb/webview/set-title.js
// module id = 667
// module chunks = 0